import { Injectable } from "@angular/core";
import { LocalNotifications } from "@ionic-native/local-notifications";
import { TranslateService } from "@ngx-translate/core";
import moment from 'moment';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppPreferences } from "../../../shared/local/app-preferences.local";
import { RequestGetEmpDto } from "../../../shared/nestjs/gd-all-in-one/dto/sf-career.dto";
import { RequestMatrixAttendanceDto, RequestShiftDailyList } from "../../../shared/nestjs/gd-integrated/dto/shiftschedule.dto";
import { ShiftscheduleApi } from "../../../shared/nestjs/gd-integrated/services/shiftschedule.api";
import { CareerApi } from "../../../shared/nestjs/gd-only/services/career.api";
import { NestApiProvider } from "../../../shared/nestjs/nest-api";
import { SFShiftDailySF6Api, SFShiftScheduleSF6Api } from "../../../shared/sdk/services/custom";
import { AttendanceBloc } from "../attendance/attendance.bloc";
@Injectable()
export class ShiftscheduleBloc {
  constructor(
    private appPreferences: AppPreferences,
    private translate: TranslateService,
    private nestApiProvider: NestApiProvider,
    private careerApi: CareerApi,
    private sFShiftDailySF6Api: SFShiftDailySF6Api,
    private shiftscheduleApi: ShiftscheduleApi,
    private sFShiftScheduleSF6Api: SFShiftScheduleSF6Api,
    private localNotifications: LocalNotifications,
    private attendanceBloc: AttendanceBloc,
  ) {
  }

  getEmp(payload: RequestGetEmpDto): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.careerApi.getEmp(payload)
            .pipe(
              map(res => res.data)
            );
        } else {
          return this.careerApi.getEmp(payload)
            .pipe(
              map(res => res.data)
            );
        }
      })
  }

  getShiftDailyList(payload: RequestShiftDailyList): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.shiftscheduleApi.shiftDailyList(payload)
            .pipe(
              map(res => res.data)
            );
        } else {
          return this.sFShiftDailySF6Api.getShiftDailiesListing();
        }
      })
  }

  getMatrixAttendance(payload: RequestMatrixAttendanceDto) {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.shiftscheduleApi.matrixAttendance(payload)
            .pipe(
              map(res => res.data)
            );
        } else {
          return this.sFShiftScheduleSF6Api.getMatrixAttendance(payload.listEmpid, payload.startdate, payload.enddate, payload.defaultshift)
            .pipe(
              map(res => res.hasil)
            );
        }
      })
  }

  save(payload) {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.shiftscheduleApi.save(payload);
        } else {
          return this.sFShiftScheduleSF6Api.procsave(JSON.stringify(payload));
        }
      }
      )
  }

  async setNotificationAttendance() {
    try {
      const auth = await this.appPreferences.getAuth();
      if (auth.companySetting.reminderAttendance) {
        const response = await this.attendanceBloc.getShiftList(`${moment().format('YYYY-MM-DD')}`, `${moment().add(7, 'day').format('YYYY-MM-DD')}`);
        if (response.length > 0) {
          const localNotificationData = [];
          response.forEach((item, i) => {
            if (item.shiftstarttime && item.shiftdailycode !== 'OFF') {
              const splitDate: any = item.shiftstarttime.split(/\D+/);
              const datestarttime = new Date(moment(`${splitDate[0]}-${splitDate[1]}-${splitDate[2]}`).hours(splitDate[3]).minutes(splitDate[4]).seconds(splitDate[5]).milliseconds(splitDate[6]).format());
              localNotificationData.push({
                id: Math.floor((Math.random() * 999) + 1),
                title: this.translate.instant('Ready to work?'),
                text: this.translate.instant(`Don't forget to record your attendance and do something great today!`),
                trigger: { at: new Date(datestarttime.getTime() - 120000 + 3600) },
                icon: "res://drawable-hdpi/icon",
                smallIcon: "res://drawable-hdpi/icon",
              });
            }
            if (item.shiftendtime && item.shiftdailycode !== 'OFF') {
              const splitDate: any = item.shiftendtime.split(/\D+/);
              const dateendtime = new Date(moment(`${splitDate[0]}-${splitDate[1]}-${splitDate[2]}`).hours(splitDate[3]).minutes(splitDate[4]).seconds(splitDate[5]).milliseconds(splitDate[6]).format());
              localNotificationData.push({
                id: Math.floor((Math.random() * 999) + 1),
                title: this.translate.instant(`You did great job today!`),
                text: this.translate.instant(`Don't forget to record your attendance before you go home. Have a good rest!`),
                trigger: { at: new Date(dateendtime.getTime() + 3600) },
                icon: "res://drawable-hdpi/icon",
                smallIcon: "res://drawable-hdpi/icon",
              });
            }
          });
          console.log('localNotificationData', localNotificationData);
          if (localNotificationData.length > 0) {
            await this.localNotifications.cancelAll();
            this.localNotifications.schedule(localNotificationData);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/bloc/hr/shift/shiftschedule.bloc.ts